
<div class="lm-border pa-3" >
    <div class="v-flex step-title ">
        <div class=" primary--text" style="padding-top: 3px;">
            <span>{{ $t('invoice.sum.title') }}</span>
            <span>
                {{ toMoney (invoice.item.amount.net) }}
            </span>
        </div>

        <inc-invoice-stamp-menu
            :data    = "invoice"
            @stamped = "onStamped"
            @mail    = "onSendStampMail"
            @reset   = "onReset"
            style="margin-bottom: 3px;"
        />
    </div>

    <!-- Invoice dates -->
    <p-inc-invoice-dates
        :data       = "invoice"
        :collective = "true"
    />
    <!-- Invoice dates -->

    <!-- Invoice number and invoice date -->
    <v-row class="no-frame mt-1" >
        <v-col class="no-frame pr-2">
            <v-text-field
                v-model        = "invoice.invoicenumber"
                :rules         = "[requiredOnTerminationRule]"
                :label         = "$t('invoice.invoicenumber')"
                background-color = "field-group-background-blue"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                class="label--active"
            />
        </v-col>
        <v-col class="no-frame pl-2">
            <f-date-picker
                v-model = "invoice.invoiceDate"
                label   = "invoice.invoiceDate"
                background-color="field-group-background-blue"
                :time   = "false"
            />
        </v-col>
    </v-row>

    <v-row
        v-if="showCosts"
        class = "no-frame mt-0"
    >
        <v-col
            class  = "no-frame col-6 pr-1 pl-0 primary--text"
            style="font-size: 12px; text-align: center"
        >
            Urspungsrechnung
        </v-col>
        <v-col
            class="no-frame col-6 pl-2 primary--text"
            style="font-size: 12px; text-align: center"
        >
            Korrigierte Rechnung
        </v-col>
    </v-row>
    <v-row dense class="no-frame">
        <v-col class="no-frame pr-2">
            <div class="lm-border pl-2 pr-2 pt-1 pb-1">
                <f-read-only-field
                    :label="$t('invoice.cost.net')"
                    :value="toMoney (invoice.item.calculated.net)"
                    :align-right = "true"
                    collective
                    dense
                />
                <f-read-only-field
                    v-if         = "showCosts"
                    class        = "mt-2"
                    :label       = "$t('invoice.cost.material')"
                    :value       = "toMoney (invoice.item.calculated.costMaterial)"
                    :align-right = "true"
                    collective
                    dense
                />
                <f-read-only-field
                    v-if         = "showCosts"
                    class        ="mt-2"
                    :label       ="$t('invoice.cost.wage')"
                    :value       ="toMoney (invoice.item.calculated.costWage)"
                    :align-right = "true"
                    collective
                    dense
                />
            </div>
        </v-col>

        <v-col class="no-frame pl-2">
            <div v-if="showCosts" class="lm-border pl-2 pr-2 pt-1 pb-1">
                <f-read-only-field
                    :label="$t('invoice.cost.invoice')"
                    :value="toMoney (invoice.item.correction.net)"
                    :align-right = "true"
                    collective
                    dense
                />
                <f-read-only-field
                    class="mt-2"
                    :label="$t('invoice.cost.material')"
                    :value="toMoney (invoice.item.correction.costMaterial)"
                    :align-right = "true"
                    collective
                    dense
                />
                <f-read-only-field
                    class="mt-2"
                    :label="$t('invoice.cost.wage')"
                    :value="toMoney (invoice.item.correction.costWage)"
                    :align-right = "true"
                    collective
                    dense
                />
            </div>
        </v-col>
    </v-row>
</div>
